import { render, staticRenderFns } from "./CPDocumentModal.vue?vue&type=template&id=66c8fad8&scoped=true&"
import script from "./CPDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./CPDocumentModal.vue?vue&type=script&lang=ts&"
import style0 from "./CPDocumentModal.vue?vue&type=style&index=0&id=66c8fad8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c8fad8",
  null
  
)

export default component.exports